import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link, useNavigate } from 'react-router-dom';
import { customerSignupSchema } from '@waw/validation-schemas';
import { useAuth } from '../../auth/AuthContext.jsx';
import '../auth/Login.css';

export default function SignUp() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [serverError, setServerError] = useState('');

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(customerSignupSchema),
  });

  const onSubmit = async (data) => {
    setServerError('');
    try {
      await signup(data);
      navigate('/compte/profil', { replace: true });
    } catch (err) {
      if (err.status === 409) {
        setServerError('Un compte existe déjà avec cet email.');
      } else if (err.status === 429) {
        setServerError('Trop de tentatives, réessayez dans quelques instants.');
      } else {
        setServerError(err.message || 'Une erreur est survenue.');
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="card auth-card">
        <h1 className="auth-title">Inscription</h1>
        <p className="auth-subtitle">Créez votre compte WAW</p>

        {serverError && <div className="auth-error-banner">{serverError}</div>}

        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="form-group">
            <label className="form-label" htmlFor="signup-first">Prénom</label>
            <input
              id="signup-first"
              type="text"
              className={`form-input${errors.firstName ? ' error' : ''}`}
              placeholder="Votre prénom"
              autoComplete="given-name"
              {...register('firstName')}
            />
            {errors.firstName && <span className="form-error">{errors.firstName.message}</span>}
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="signup-last">Nom</label>
            <input
              id="signup-last"
              type="text"
              className={`form-input${errors.lastName ? ' error' : ''}`}
              placeholder="Votre nom"
              autoComplete="family-name"
              {...register('lastName')}
            />
            {errors.lastName && <span className="form-error">{errors.lastName.message}</span>}
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="signup-email">Email</label>
            <input
              id="signup-email"
              type="email"
              className={`form-input${errors.email ? ' error' : ''}`}
              placeholder="votre@email.com"
              autoComplete="email"
              {...register('email')}
            />
            {errors.email && <span className="form-error">{errors.email.message}</span>}
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="signup-phone">Téléphone</label>
            <input
              id="signup-phone"
              type="tel"
              className={`form-input${errors.phone ? ' error' : ''}`}
              placeholder="+212 6XX XXX XXX"
              autoComplete="tel"
              {...register('phone')}
            />
            {errors.phone && <span className="form-error">{errors.phone.message}</span>}
            <span className="form-hint">Optionnel - format marocain</span>
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="signup-password">Mot de passe</label>
            <input
              id="signup-password"
              type="password"
              className={`form-input${errors.password ? ' error' : ''}`}
              placeholder="8 caracteres minimum"
              autoComplete="new-password"
              {...register('password')}
            />
            {errors.password && <span className="form-error">{errors.password.message}</span>}
          </div>

          <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={isSubmitting}>
            {isSubmitting ? 'Creation...' : 'Creer mon compte'}
          </button>
        </form>

        <div className="auth-footer">
          Deja inscrit ? <Link to="/compte/connexion">Se connecter</Link>
        </div>
      </div>
    </div>
  );
}
